import { Button, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, usePopup, useTheme } from "@/comn/hooks";
import { Link, useLocation } from "react-router-dom";
import {
    APIS,
    BASE,
    SF_SPORT_LGN_INFO,
    SF_SPORT_LGN_SRCH,
} from "@/tra/tancis/ptli/sysm/sport/services/PtliSportService";
import { comnUtils } from "@/comn/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import theme from "tailwindcss/defaultTheme";
// import { useRemoteLogin } from "@/comn/features/authentication/useRemoteLogin"; // TODO: useRemoteLogin not implemented in dev branch

/*
 * Remote Work Support
 * !== 원격업무 지원 ==!
 */
export const PTLI1020001Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const { t } = useTranslation();
    const { theme } = useTheme();
    const popup = usePopup();
    // const remoteLogin = useRemoteLogin(); // TODO: useRemoteLogin not implemented in dev branch
    const [isNeedCoTp, setNeedCoTp] = useState<boolean>(false);
    const [coTpOptions, setCoTpOptions] = useState<any[]>([]);
    const [coTp, setCoTp] = useState<any | null>(null);

    const options = [
        { label: t("L_XTRN_USR"), value: "EXT" },
        { label: t("L_LCNE_USR"), value: "LCM" },
        { label: t("L_OGA_USR"), value: "OGA" },
    ];

    // const coTpListOptions: any[] = [];

    const form = {
        sportLgnSrch: useForm({ defaultSchema: SF_SPORT_LGN_SRCH }),
        sportLgnInfo: useForm({ defaultSchema: SF_SPORT_LGN_INFO }),
    };

    const fetch = {
        getUserInfo: useFetch({
            api: () => APIS.getUsrInfo(form.sportLgnSrch.getValues()),
            onSuccess: (data: any) => {
                const {
                    usrInfo: { content },
                    extUsrCoTpList: { content: extUsrCoTpList },
                } = data;

                if (comnUtils.isEmpty(content)) {
                    form.sportLgnInfo.clearValues();
                    modal.openModal({ content: "msg.com.00105" }); // No data found. !== 조회된 데이터가 없습니다. ==!'
                    return;
                }

                setCoTp(null);
                if (!!content.coDclaCd && content.lgnTp === "EXT") {
                    const options: any[] = (extUsrCoTpList || []).map((item: any) => {
                        return { label: `[${item.coDclaCd}] ${item.coDclaCdNm}`, value: item.coDclaCd, ...item };
                    });

                    setCoTpOptions(options);
                    setNeedCoTp(true);

                    if (options.length === 1 && (!coTp || coTp?.coDclaCd != options[0].coDclaCd)) {
                        setCoTp(options[0]);
                    }
                } else {
                    setCoTpOptions([]);
                    setNeedCoTp(false);
                    setCoTp(null);
                }

                form.sportLgnInfo.setValues(content);
            },
        }),
    };

    const handler = {
        onBtnSrchClick: form.sportLgnSrch.handleSubmit(() => fetch.getUserInfo.fetch()),

        onLoginClick: () => {
            // TODO: Remote login feature not implemented yet
            modal.openModal({
                content: "Remote login feature is not available yet. (원격 로그인 기능이 아직 구현되지 않았습니다.)"
            });
            console.log("onLoginClick called - useRemoteLogin not implemented");

            /* Original implementation - commented out until useRemoteLogin is implemented
            let lgnInfo: any = form.sportLgnInfo.getValues();
            if (isNeedCoTp && !!coTp?.coDclaCd) {
                const { coTin, coDclaTp, coDclaCd } = coTp;
                lgnInfo = { ...lgnInfo, coTin: coTin, coTpCd: coDclaTp, coCd: coDclaCd };
            }

            remoteLogin.openRemoteLogin(lgnInfo, form.sportLgnSrch.getValue("usrTp"), "INT");
            */
        },
    };

    useEffect(() => {
        form.sportLgnSrch.setValue("usrTp", "EXT");
        //form.sportLgnInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.sportLgnSrch.schema.usrId} />
                            <Group.Control {...form.sportLgnSrch.schema.usrTp} options={options} />
                        </Group.Row>
                    </Group.Section>

                    <Layout.Right>
                        <Button role={"search"} onClick={handler.onBtnSrchClick} />
                    </Layout.Right>
                </Group.Body>
            </Group>

            {!comnUtils.isEmpty(form.sportLgnInfo.getValue("usrId")) && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.sportLgnInfo.schema.usrId} />
                                <Group.Control {...form.sportLgnInfo.schema.usrNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.sportLgnInfo.schema.telNo} />
                                <Group.Control {...form.sportLgnInfo.schema.moblNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.sportLgnInfo.schema.emlAddr} />
                                <Group.Control {...form.sportLgnInfo.schema.usrStatCd} />
                            </Group.Row>
                        </Group.Section>
                        {!comnUtils.isEmpty(form.sportLgnInfo.getValue("coTin")) && (
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.sportLgnInfo.schema.coNm} />
                                    <Group.Control {...form.sportLgnInfo.schema.coRppnNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.sportLgnInfo.schema.coTelNo} />
                                    <Group.Control {...form.sportLgnInfo.schema.coFaxNo} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.sportLgnInfo.schema.coAddr} />
                                    <Group.Control {...form.sportLgnInfo.schema.coEmlAddr} />
                                </Group.Row>
                            </Group.Section>
                        )}

                        {form.sportLgnInfo.getValue("lgnTp") === "EXT" &&
                            !comnUtils.isEmpty(form.sportLgnInfo.getValue("orgNm")) && (
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.sportLgnInfo.schema.orgNm} />
                                        <Group.Control {...form.sportLgnInfo.schema.orgDeptNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.sportLgnInfo.schema.orgTelno} />
                                        <Group.Control {...form.sportLgnInfo.schema.orgFaxNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.sportLgnInfo.schema.orgPhysAddr} />
                                        <Group.Control {...form.sportLgnInfo.schema.orgPostAddr} />
                                    </Group.Row>
                                </Group.Section>
                            )}

                        {isNeedCoTp && (
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control
                                        label="L_CO_CD"
                                        type="select"
                                        required={true}
                                        select={coTpOptions?.length != 1}
                                        options={coTpOptions}
                                        value={coTp?.value || ""}
                                        onChange={(val) => {
                                            const selected =
                                                coTpOptions.find((item) => {
                                                    return item.value === val;
                                                }) || {};
                                            setCoTp(selected);
                                        }}
                                    />
                                </Group.Row>
                            </Group.Section>
                        )}
                        <Layout.Right>
                            {!isNeedCoTp || !!coTp?.coDclaCd ? (
                                <Button onClick={handler.onLoginClick}>LOGIN</Button>
                            ) : (
                                <Button disabled title="select Company Code">
                                    LOGIN
                                </Button>
                            )}
                        </Layout.Right>
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
